import { Component, h, Host } from '@stencil/core';

import { addClass, hasClass, removeClass } from '../../helpers/helpers';

@Component({
  tag: 'cms-toggle-theme',
  styleUrl: 'cms-toggle-theme.scss',
  shadow: true,
})
export class CmsToggleTheme {
  private hostname: string;
  private stage: string;
  /*    private themeClassLight = 'cms-light-theme';  */
  private themeClassDark = 'cms-dark-theme';
  private nodeBody: HTMLBodyElement;
  private pageWrapper: HTMLElement;

  private themeButtonIsVisible: boolean;

  private getStage(hostname: string) {
    return hostname == 'localhost' ? hostname : hostname.split('.')[0];
  }

  private toggleThemeClass() {
    if (hasClass(this.nodeBody, this.themeClassDark)) {
      removeClass(this.nodeBody, this.themeClassDark);
      return;
    }
    this.pageWrapper?.style.setProperty(
      'background-color',
      'var(--cms-theme-background-color)',
    );
    this.nodeBody?.style.setProperty(
      'background-color',
      'var(--cms-theme-background-color)',
    );
    addClass(this.nodeBody, this.themeClassDark);
  }

  private checkStage(stage: string) {
    this.themeButtonIsVisible = ['localhost', 'dev', 'int'].includes(stage);
  }

  componentWillLoad() {
    this.hostname = window.location.hostname;
    this.stage = this.getStage(this.hostname);
    this.nodeBody = document.querySelector('body');
    this.pageWrapper = document.querySelector('.container-fluid');
    this.checkStage(this.stage);
  }
  render() {
    return (
      <Host>
        {this.themeButtonIsVisible === true ? (
          <div class={'theme-toggle-wrapper'}>
            <button
              class={'toggle-theme'}
              onClick={() => {
                this.toggleThemeClass();
              }}
              type='button'
            >
              toggle Theme
            </button>
          </div>
        ) : null}
      </Host>
    );
  }
}
